// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "9cb2af4647734b2ff93193d5a20fb67713920768/static/css/" + chunkId + "." + {"481":"144724f8","688":"c3664be3","729":"40937596"}[chunkId] + ".chunk.css";
};